import { render, staticRenderFns } from "./ItemCardData.vue?vue&type=template&id=5b25cd24&scoped=true"
import script from "./ItemCardData.vue?vue&type=script&lang=ts"
export * from "./ItemCardData.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b25cd24",
  null
  
)

export default component.exports